import { App as AntdApp, notification as notificationApi } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import type { ReactNode } from 'react';

// antd's contextual message / notification / modal API plus a notification bound to <body>
type AntdAppApi = ReturnType<typeof AntdApp.useApp> & {
  bodyNotification: NotificationInstance;
};

let appApi: AntdAppApi | undefined;

export const getAntdAppApi = () => appApi;

export const AntdAppBridge = ({ children }: { children?: ReactNode }) => {
  const contextualApi = AntdApp.useApp();
  const [bodyNotification, bodyNotificationHolder] =
    notificationApi.useNotification({
      getContainer: () => document.body,
      top: 96,
    });

  appApi = {
    ...contextualApi,
    bodyNotification,
  };

  return (
    <>
      {bodyNotificationHolder}
      {children}
    </>
  );
};
